import { useRef } from "react";
import { ImagePlus } from "lucide-react";
import { toast } from "sonner";

export const logoUrl = (c) => (c?.logo_path ? `${process.env.REACT_APP_BACKEND_URL}/api/public/logos/${c.id}?v=${encodeURIComponent(c.logo_path.slice(-12))}` : null);

export default function LogoPicker({ file, onChange, current }) {
  const input = useRef(null);
  const preview = file ? URL.createObjectURL(file) : current;
  const pick = (f) => {
    if (!f) return;
    if (!["image/png", "image/jpeg", "image/webp"].includes(f.type)) { toast.error("Logo : PNG, JPG ou WEBP uniquement"); return; }
    if (f.size > 2 * 1024 * 1024) { toast.error("Le logo doit faire moins de 2 Mo"); return; }
    onChange(f);
  };
  return (
    <div className="flex items-center gap-4">
      <div className="grid h-16 w-16 place-items-center overflow-hidden rounded-xl border bg-slate-50">
        {preview ? <img src={preview} alt="Logo" className="h-full w-full object-contain" data-testid="logo-preview" /> : <ImagePlus className="h-6 w-6 text-slate-400" />}
      </div>
      <input ref={input} type="file" accept=".png,.jpg,.jpeg,.webp" className="hidden" onChange={(e) => pick(e.target.files?.[0])} data-testid="logo-input" />
      <button type="button" onClick={() => input.current.click()} className="text-sm font-medium text-blue-600 hover:underline" data-testid="logo-pick-button">
        {preview ? "Changer le logo" : "Ajouter un logo (PNG, JPG, WEBP, 2 Mo max)"}
      </button>
    </div>
  );
}
